import { extendTheme } from "@chakra-ui/react";
import foundations from "./foundations";
import * as components from "./components";
const config = {
    initialColorMode: "light",
    useSystemColorMode: false,
};
const theme = extendTheme(Object.assign(Object.assign({ config }, foundations), { components: Object.assign({}, components) }));
export default theme;
//# sourceMappingURL=index.js.map